<template>
  <FractionsOverview />
</template>

<script>
import FractionsOverview from '@/components/Fractions/index'

export default {
  name: 'CompaniesFractionsIndexView',
  components: { FractionsOverview },
}
</script>
